import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { StatTypes } from '../../constants/CentricConstants'
import { browserHistory } from "react-router";

import MyModuleSegment from './MyModuleSegment';

import ModuleActions from '../../actions/ModuleActionCreator';
import StatStore from '../../stores/StatStore';

class MyModuleContainer extends Component {

    constructor(props) {
        super(props);

        this.state = {
            title: 'My modules',
            totals: [],
        };
    }

    componentWillMount() {
        this.getStats();
    }

    componentDidMount() {
        this.getStats = this.getStats.bind(this);
        this.onElementsClick = this.onElementsClick.bind(this);
        this.statListener = StatStore.addListener(this.getStats);
        ModuleActions.getMyStats(this.props.completed);
    }

    componentWillUnmount() {
        this.statListener.remove();
    }

    render() {
        return (
            <MyModuleSegment
                title={!this.props.completed ? 'My Modules' : 'My Modules (Completed)'}
                totals={this.state.totals}
                onElementsClick={this.onElementsClick}
                completed={this.props.completed}
            />
        );
    }

    getStats() {
        const type = this.props.completed === undefined ? StatTypes.MY_MODULES : (!!this.props.completed ? StatTypes.MY_MODULES_COMPLETED : StatTypes.MY_MODULES_NOT_COMPLETED);
        if (!StatStore.has(type)) { return; } //guard

        const stats = StatStore.get(type);
        this.setState({totals: [Number(stats.classroom), Number(stats.elearning), Number(stats.resource), Number(stats.video)]});
    }

    onElementsClick(elems) {
        if (elems.length !== 1) { return; } //guard

        let url = `/dashboard/mytraining/modules/${elems[0]._view.label.toLowerCase()}`;
        if (this.props.completed !== undefined) {
            url = `${url}?completed=${this.props.completed}`;
        }
        browserHistory.push(url);
    }
}



MyModuleContainer.propTypes = {
    userId: PropTypes.number.isRequired,
    menuItems: PropTypes.array,
    completed: PropTypes.bool
};

MyModuleContainer.contextTypes = {
    auth: PropTypes.object.isRequired
};

export default MyModuleContainer;
